import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import DesktopAssets from './DesktopAssets';
import getStyles from './getStyles';
import { getImageRatio } from '../../utils/ProductUtils';
import CarouselThumbs from '../../shared/Carousel/CarouselThumbs';

function Featured(props) {
  const { Block } = UX2.Element;
  const {
    Grid,
    Grid: { Cell }
  } = UX2.Component;
  const styles = getStyles(props);

  return (
    <Block style={ styles.featuredContainer }>
      <Grid size={ 12 }>
        <Cell sm={ 2 } style={ styles.featuredThumbContainer }>
          <CarouselThumbs { ...props } vertical />
        </Cell>
        <Cell sm={ 8 }>
          <Block style={ styles.wrapperDesktop }>
            <Block style={ styles.imageWrapper }>
              <Block style={ styles.imageOuter }>
                <DesktopAssets
                  selectedAsset={ props.selectedAsset }
                  product={ props.product }
                  zoomConfig={{
                    disableZoom: !props.zoomEnabled,
                    containerStyle: {
                      position: 'relative',
                      height: '450px',
                      overflow: 'hidden'
                    },
                    enlargedImagePosition: 'over',
                    cropMethod: props.pdpImageCropMethod
                  }}
                  aspectRatio={ getImageRatio(props.pdpImageShape, props.pdpLayout) }
                />
              </Block>
            </Block>
          </Block>
        </Cell>
      </Grid>
    </Block>
  );
}

Featured.propTypes = {
  assets: PropTypes.array,
  hasFinalizedAssets: PropTypes.bool,
  isCurrentAsset: PropTypes.bool,
  onClickThumbnail: PropTypes.func,
  pdpImageCropMethod: PropTypes.string,
  product: PropTypes.object,
  selectedAsset: PropTypes.object,
  zoomEnabled: PropTypes.bool,
  pdpImageShape: PropTypes.string,
  pdpLayout: PropTypes.string.isRequired
};

export default Featured;
